import { render, staticRenderFns } from "./RedPack.vue?vue&type=template&id=409ec22a"
import script from "./RedPack.vue?vue&type=script&lang=js"
export * from "./RedPack.vue?vue&type=script&lang=js"
import style0 from "./RedPack.vue?vue&type=style&index=0&id=409ec22a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports